/**
 * @module
 */

/**
 * @import {UserProfileData} from '../model/user-profile.js'
 */
import {undefined} from '@acng/frontend-bounty/std/value.js';
import {RemoveController, NamespaceController, service, reactive} from 'nova';

import userDummySrc from '../../../basic/img/noImg.png';
import {asset, make, media} from '../../core/service/env.js';
import {user} from '../user.js';
import {GUEST} from '../model/dictionary.js';
import {ProfileChange} from './change.js';
import {Preference} from './preference.js';
import {UserProfileApi} from 'acng/api/user-profile.js';
import {UserImageUpload} from '../image-upload.js';

/**
 * Change user profile
 */
@service
class UserProfile extends NamespaceController {
  //DEBUG = true;
  #api = make(UserProfileApi);
  change = new ProfileChange(this);
  preference = new Preference(this, 'preference');
  experience = new Preference(this, 'experience');
  lookingfor = new Preference(this, 'lookingfor');
  male = new RemoveController(false);
  female = new RemoveController(false);
  imageUpload = new UserImageUpload();
  @reactive accessor image = asset(userDummySrc);

  /**
   * @type {UserProfileData | undefined | null}
   */
  #data;

  /** @override */
  get hidden() {
    if (user[GUEST]) {
      this.#data = undefined;

      return true;
    }

    return false;
  }

  /**
   * @returns {Promise<UserProfileData | null>}
   *
   * @override
   */
  get setup() {
    return (async () => {
      const data = await this.#api.get();

      this.#data = data;
      this.male.condition = data.gender == 'm';
      this.female.condition = data.gender == 'f';

      const images = data?.images;
      this.image = images ? media.user + images.wide[900] : asset(userDummySrc);

      return data;
    })();
  }

  /**
   * @returns {UserProfileData}
   *
   * @throws {UserProfile}
   */
  get data() {
    const ctrl = this;

    if (!ctrl.#data) {
      throw ctrl;
    }

    return ctrl.#data;
  }
}

export {UserProfile};
